export default function Error({ message }) {
  return <p style={{ color: "red" }}>{message}</p>;
}